import { gql } from 'apollo-angular'

export const GET_PRODUCTS = gql`
  query Products($limit: Int) {
    Products(
      select: true
      limit: $limit
      where: { archived: { not_equals: true } }
    ) {
      docs {
        id
        name
        magazine {
          title
          media {
            cover {
              url
            }
          }
          archived
        }
        product_options {
          docs {
            invoicing {
              price
              tax_rate
            }
            from_seats
            seat_value
            name
            type
            id
          }
        }
        productType
        description
      }
    }
  }
`
